<template>
  <div class="w-70rem m-auto" v-if="newsDetail">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="pb-3">
      <el-breadcrumb-item :to="{ name: 'Home' }">{{
        $t("首页")
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("热门资讯") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ newsDetail.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="bg-white py-8 px-10">
      <div class="border-b pb-6">
        <p class="text-xl font-medium">{{ newsDetail.title }}</p>
        <p class="space-x-10 py-5 text-sm">
          <span class=""
            >{{ $t("发布时间") }}：{{ newsDetail.created.date }}</span
          >
          <span>{{ $t("浏览次数") }}：{{ newsDetail.browse }}</span>
        </p>
      </div>
      <div class="pt-6 text-black">
        <p class="shrink text-base leading-2rem">
          {{ delHtmlTag(newsDetail.content) }}
        </p>
        <div class="w-full h-40rem py-2">
          <img
            :src="$firstImage(newsDetail.viewimage, 'normal')"
            class="img"
            v-if="newsDetail.viewimage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const news_id = ref(ctx.root.$route.query.id);
    const newsDetail = ref();

    const getNewsDetail = async (id) => {
      const res = await ctx.root.$callapi("news/getNewsDetail", {
        news_id: id,
      });
      newsDetail.value = res.data;
    };
    const viewObj = async (id) => {
      await ctx.root.$callapi("viewObj", {
        objid: id,
        tag: "news",
      });
    };
    onMounted(() => {
      getNewsDetail(news_id.value);
      viewObj(news_id.value);
    });
    //去除html 标签
    const delHtmlTag = (str) => {
      return str.replace(/<[^>]+>/g, "");
    };

    return { newsDetail, delHtmlTag };
  },
};
</script>
<style scoped lang="scss">

.shrink {
  text-indent: 2em;
  text-align: left;
}

</style>